(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-find-snacks-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const groupMap = {
      mission: {
        attr: 'findMission',
        param: 'find_mission',
      },
      snack_type: {
        attr: 'findType',
        param: 'find_type',
      },
      flavor_profile: {
        attr: 'findFlavor',
        param: 'find_flavor',
      },
      country: {
        attr: 'findCountry',
        param: 'find_country',
      },
    };

    const paramToGroup = Object.entries(groupMap).reduce((accumulator, [group, config]) => {
      accumulator[config.param] = group;
      return accumulator;
    }, {});

    const formatCount = (count) => `${count} ${count === 1 ? 'Item' : 'Items'} Found`;

    const splitValues = (value) => {
      if (!value) return [];
      return value.split(/\s+/).filter(Boolean);
    };

    const getStateFromInputs = (checkboxes) => {
      const state = {};
      Object.keys(groupMap).forEach((group) => {
        state[group] = [];
      });

      checkboxes.forEach((input) => {
        if (input.checked && state[input.dataset.filterGroup]) {
          state[input.dataset.filterGroup].push(input.value);
        }
      });

      return state;
    };

    const hasFilters = (state) => Object.values(state).some((values) => values.length > 0);

    const initShell = (shell) => {
      if (shell.dataset.gsFindSnacksReady === 'true') return;
      shell.dataset.gsFindSnacksReady = 'true';
      document.documentElement.classList.add('gs-find-snacks-page');
      document.body.classList.add('gs-find-snacks-page');

      const resetHorizontalScroll = () => {
        if (window.scrollX !== 0) {
          window.scrollTo(0, window.scrollY);
        }
      };

      [0, 250, 1000, 2500, 5000].forEach((delay) => {
        window.setTimeout(resetHorizontalScroll, delay);
      });
      window.addEventListener('resize', resetHorizontalScroll, { passive: true });
      window.addEventListener('scroll', resetHorizontalScroll, { passive: true });

      const dialog = shell.querySelector('[data-gs-finder-dialog]');
      const openButtons = shell.querySelectorAll('[data-gs-finder-open]');
      const closeButton = shell.querySelector('[data-gs-finder-close]');
      const resetButton = shell.querySelector('[data-gs-filter-reset]');
      const applyButton = shell.querySelector('[data-gs-filter-apply]');
      const results = shell.querySelector('[data-gs-filter-results]');
      const clearButtons = shell.querySelectorAll('[data-gs-filter-clear]');
      const chipsContainer = shell.querySelector('[data-gs-active-chips]');
      const filterCountTargets = shell.querySelectorAll('[data-gs-filter-count]');
      const resultsViewAll = shell.querySelector('[data-gs-results-view-all]');
      const selectedTarget = shell.querySelector('[data-gs-filter-selected]');
      const resultCards = Array.from(shell.querySelectorAll('[data-gs-result-card]'));
      const resultsGrid = shell.querySelector('[data-gs-results-grid]');
      const emptyState = shell.querySelector('[data-gs-results-empty]');
      const sortControl = shell.querySelector('[data-gs-filter-sort]');
      const checkboxes = Array.from(shell.querySelectorAll('[data-filter-group]'));
      const brandGrid = shell.querySelector('[data-gs-brand-grid]');
      const brandCards = brandGrid ? Array.from(brandGrid.querySelectorAll('[data-gs-brand-card]')) : [];
      let committedState = {};
      let activeTrigger = null;
      let originalCards = [];
      let productWindowExpanded = false;
      const previewProductLimit = 6;
      const filteredProductLimit = 9;
      const resultLayoutClasses = [
        'is-featured-result',
        'is-featured-result--left',
        'is-featured-result--right',
        'is-featured-result--center',
      ];

      Object.keys(groupMap).forEach((group) => {
        committedState[group] = [];
      });

      resultCards.forEach((card, index) => {
        card.dataset.originalIndex = String(index);
      });
      originalCards = [...resultCards];

      brandCards.forEach((card, index) => {
        card.dataset.originalIndex = String(index);
      });

      const arrangeBrandGrid = () => {
        if (!brandGrid || brandCards.length === 0) return;

        const sortedBrands = [...brandCards].sort((a, b) => {
          const countDiff = Number(b.dataset.gsBrandCount || 0) - Number(a.dataset.gsBrandCount || 0);
          if (countDiff !== 0) return countDiff;
          return Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0);
        });

        if (brandGrid.dataset.gsBrandRail === 'true') {
          brandGrid.dataset.gsBrandColumnCount = String(sortedBrands.length);
          brandGrid.dataset.gsBrandVisibleCount = String(sortedBrands.length);
          sortedBrands.forEach((card) => {
            card.hidden = false;
            brandGrid.append(card);
          });
          brandGrid.scrollLeft = 0;
          return;
        }

        const columnCount = (() => {
          const columns = window.getComputedStyle(brandGrid).gridTemplateColumns.trim().split(/\s+/).filter(Boolean).length;
          return Math.max(columns, 1);
        })();
        const maxRows = 2;
        const maxVisibleBrands = columnCount * maxRows;
        let visibleBrandCount = Math.min(sortedBrands.length, maxVisibleBrands);

        if (brandGrid.dataset.gsBrandEvenCount === 'true' && visibleBrandCount > columnCount) {
          const remainder = visibleBrandCount % columnCount;
          if (remainder === 1) {
            visibleBrandCount -= 1;
          }
        }

        brandGrid.dataset.gsBrandColumnCount = String(columnCount);
        brandGrid.dataset.gsBrandVisibleCount = String(visibleBrandCount);

        sortedBrands.forEach((card, index) => {
          card.hidden = index >= visibleBrandCount;
          brandGrid.append(card);
        });
      };

      arrangeBrandGrid();

      let brandResizeFrame = null;
      window.addEventListener('resize', () => {
        if (brandResizeFrame) {
          window.cancelAnimationFrame(brandResizeFrame);
        }
        brandResizeFrame = window.requestAnimationFrame(() => {
          brandResizeFrame = null;
          arrangeBrandGrid();
        });
      });

      const tabButtons = Array.from(shell.querySelectorAll('[data-gs-discovery-tab]'));
      const tabPanels = Array.from(shell.querySelectorAll('[data-gs-tab-panel]'));

      const activateDiscoveryTab = (button) => {
        const group = button.dataset.gsTabGroup;
        const targetId = button.dataset.gsTabTarget;
        if (!group || !targetId) return;

        tabButtons
          .filter((tabButton) => tabButton.dataset.gsTabGroup === group)
          .forEach((tabButton) => {
            const isActive = tabButton === button;
            tabButton.classList.toggle('is-active', isActive);
            tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

        tabPanels
          .filter((panel) => panel.dataset.gsTabGroup === group)
          .forEach((panel) => {
            panel.hidden = panel.id !== targetId;
          });
      };

      tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activateDiscoveryTab(button);
        });
      });

      const getLabel = (group, value) => {
        const input = checkboxes.find((checkbox) => checkbox.dataset.filterGroup === group && checkbox.value === value);
        return input ? input.dataset.filterLabel : value;
      };

      const getMatches = (state) => {
        return resultCards.filter((card) => {
          return Object.entries(groupMap).every(([group, config]) => {
            const selectedValues = state[group] || [];
            if (selectedValues.length === 0) return true;
            const cardValues = splitValues(card.dataset[config.attr]);
            return selectedValues.some((selectedValue) => cardValues.includes(selectedValue));
          });
        });
      };

      const cloneState = (state) => {
        const clonedState = {};
        Object.keys(groupMap).forEach((group) => {
          clonedState[group] = [...(state[group] || [])];
        });
        return clonedState;
      };

      const refreshOptionAvailability = (state) => {
        const baseState = cloneState(state || getStateFromInputs(checkboxes));

        checkboxes.forEach((input) => {
          const group = input.dataset.filterGroup;
          if (!groupMap[group]) return;

          const testState = cloneState(baseState);
          if (!input.checked) {
            testState[group] = [input.value];
          }

          const hasMatches = getMatches(testState).length > 0;
          const label = input.closest('label');
          input.disabled = !input.checked && !hasMatches;
          if (label) {
            label.hidden = !input.checked && !hasMatches;
          }
        });
      };

      const updateCount = (count) => {
        filterCountTargets.forEach((target) => {
          target.textContent = formatCount(count);
        });
        if (applyButton) {
          applyButton.textContent = `View ${count} ${count === 1 ? 'Item' : 'Items'}`;
        }
      };

      const updateResultsWindowCopy = (totalCount, visibleCount, filteredMode) => {
        if (resultsViewAll) {
          const shouldShowViewAll = filteredMode && totalCount > visibleCount;
          resultsViewAll.hidden = !shouldShowViewAll;
          resultsViewAll.textContent = `View all ${totalCount} ${totalCount === 1 ? 'item' : 'items'}`;
        }
      };

      const syncInputsFromState = () => {
        checkboxes.forEach((input) => {
          input.checked = (committedState[input.dataset.filterGroup] || []).includes(input.value);
        });
      };

      const updateDialogSummary = () => {
        const draftState = getStateFromInputs(checkboxes);
        const matches = getMatches(draftState);
        refreshOptionAvailability(draftState);
        updateCount(matches.length);

        const labels = [];
        Object.entries(draftState).forEach(([group, values]) => {
          values.forEach((value) => labels.push(getLabel(group, value)));
        });

        if (selectedTarget) {
          selectedTarget.textContent = labels.length > 0 ? labels.join(', ') : 'Choose filters to narrow the catalog.';
        }
      };

      const renderChips = () => {
        if (!chipsContainer) return;
        chipsContainer.innerHTML = '';

        Object.entries(committedState).forEach(([group, values]) => {
          values.forEach((value) => {
            const chip = document.createElement('button');
            const label = getLabel(group, value);
            chip.type = 'button';
            chip.textContent = `${label} ×`;
            chip.setAttribute('aria-label', `Remove ${label} filter`);
            chip.addEventListener('click', () => {
              committedState[group] = committedState[group].filter((currentValue) => currentValue !== value);
              productWindowExpanded = false;
              syncInputsFromState();
              renderResults(true, true);
            });
            chipsContainer.append(chip);
          });
        });

        chipsContainer.hidden = chipsContainer.children.length === 0;
      };

      const sortCards = (cards) => {
        const sortValue = sortControl ? sortControl.value : 'recommended';
        const sortedCards = [...cards];

        if (sortValue === 'price-asc') {
          sortedCards.sort((a, b) => Number(a.dataset.price || 0) - Number(b.dataset.price || 0));
        } else if (sortValue === 'price-desc') {
          sortedCards.sort((a, b) => Number(b.dataset.price || 0) - Number(a.dataset.price || 0));
        } else {
          sortedCards.sort((a, b) => Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0));
        }

        return sortedCards;
      };

      const cardHasAnyToken = (card, datasetKey, tokens) => {
        const values = splitValues(card.dataset[datasetKey]).map((value) => value.toLowerCase());
        return tokens.some((token) => values.includes(token));
      };

      const cardHasAnyText = (card, tokens) => {
        const searchText = `${card.dataset.findType || ''} ${card.dataset.title || ''}`.toLowerCase();
        return tokens.some((token) => searchText.includes(token));
      };

      const getPreviewCardRank = (card) => {
        const bestSellerBoost = cardHasAnyToken(card, 'findMission', ['best-sellers', 'best-seller']) ? -1000 : 0;
        return bestSellerBoost + Number(card.dataset.originalIndex || 0);
      };

      const getPreviewShowcaseCards = (cards) => {
        const rankedCards = [...cards].sort((a, b) => getPreviewCardRank(a) - getPreviewCardRank(b));
        const selectedCards = [];
        const selectedSet = new Set();
        const previewGroups = [
          ['drinks', 'drink', 'soda', 'cola', 'fanta', 'pepsi', 'coke', 'beverage'],
          ['candy', 'chocolate', 'gummies', 'gummy', 'skittles', 'starburst', 'snickers'],
          ['chips', 'chip', 'crisps', 'doritos', 'lays', 'pringles'],
          ['cookies', 'cookie', 'biscuit', 'biscuits', 'oreo'],
        ];

        const addCard = (card) => {
          if (!card || selectedSet.has(card)) return;
          selectedSet.add(card);
          selectedCards.push(card);
        };

        previewGroups.forEach((groupTokens) => {
          addCard(rankedCards.find((card) => !selectedSet.has(card) && cardHasAnyText(card, groupTokens)));
        });

        rankedCards.forEach((card) => {
          if (selectedCards.length < previewProductLimit) {
            addCard(card);
          }
        });

        return [...selectedCards, ...cards.filter((card) => !selectedSet.has(card))];
      };

      const updateUrl = () => {
        const url = new URL(window.location.href);
        Object.values(groupMap).forEach((config) => {
          url.searchParams.delete(config.param);
        });
        url.searchParams.delete('find_sort');

        Object.entries(committedState).forEach(([group, values]) => {
          if (values.length > 0) {
            url.searchParams.set(groupMap[group].param, values.join(','));
          }
        });

        if (sortControl && sortControl.value !== 'recommended') {
          url.searchParams.set('find_sort', sortControl.value);
        }

        window.history.replaceState({}, '', url);
      };

      const getResultsColumnCount = () => {
        if (!resultsGrid) return 1;
        const columns = window.getComputedStyle(resultsGrid).gridTemplateColumns.trim().split(/\s+/).filter(Boolean);
        return Math.max(columns.length, 1);
      };

      const getBalancedWindowLimit = (totalCount, baseLimit, layoutExtraCells) => {
        if (totalCount <= baseLimit) return totalCount;
        const columns = getResultsColumnCount();
        let limit = Math.min(baseLimit, totalCount);
        const remainder = (limit + layoutExtraCells) % columns;

        if (remainder > 0) {
          limit = Math.min(totalCount, limit + columns - remainder);
        }

        return limit;
      };

      const shouldFeatureResult = (index, visibleCount, filteredMode) => {
        if (index === 0) return true;
        if (!filteredMode) return false;
        if (!productWindowExpanded || index % 12 !== 0) return false;
        return visibleCount - index > 8;
      };

      const renderResults = (showResults, shouldUpdateUrl) => {
        const filteredMode = hasFilters(committedState);
        const matches = getMatches(committedState);
        const shouldShowResults = matches.length > 0 || filteredMode || showResults;
        const sortedMatches = sortCards(matches);
        const orderedMatches = filteredMode ? sortedMatches : getPreviewShowcaseCards(sortedMatches);
        const estimatedLayoutExtraCells = 3;
        const windowLimit = productWindowExpanded
          ? orderedMatches.length
          : getBalancedWindowLimit(orderedMatches.length, filteredMode ? filteredProductLimit : previewProductLimit, estimatedLayoutExtraCells);
        const visibleMatches = productWindowExpanded ? orderedMatches : orderedMatches.slice(0, windowLimit);
        const visibleSet = new Set(visibleMatches);

        if (resultsGrid) {
          sortCards(originalCards).forEach((card) => {
            resultsGrid.append(card);
          });
          orderedMatches.forEach((card) => {
            resultsGrid.append(card);
          });
        }

        resultCards.forEach((card) => {
          card.classList.remove(...resultLayoutClasses);
          card.style.removeProperty('--gs-result-span');
          card.removeAttribute('data-gs-visible-index');
          card.hidden = !visibleSet.has(card);
        });

        visibleMatches.forEach((card, index) => {
          card.dataset.gsVisibleIndex = String(index + 1);
          if (shouldFeatureResult(index, visibleMatches.length, filteredMode)) {
            const featureIndex = Math.floor(index / 12);
            const featureSide = ['left', 'right'][featureIndex % 2];
            card.classList.add('is-featured-result', `is-featured-result--${featureSide}`);
          }
        });

        updateCount(matches.length);
        updateResultsWindowCopy(matches.length, visibleMatches.length, filteredMode);
        renderChips();

        if (results) {
          results.hidden = !shouldShowResults;
        }

        if (emptyState) {
          emptyState.hidden = !shouldShowResults || matches.length !== 0;
        }

        clearButtons.forEach((button) => {
          button.hidden = !filteredMode;
        });

        shell.classList.toggle('is-filtered', shouldShowResults);
        shell.classList.toggle('has-active-filters', filteredMode);
        refreshOptionAvailability(committedState);

        if (shouldUpdateUrl) {
          updateUrl();
        }

        if (!filteredMode && !showResults) syncInputsFromState();
      };

      const syncServerRenderedResults = () => {
        const matches = getMatches(committedState);
        const visibleMatches = resultCards.filter((card) => !card.hidden);

        updateCount(matches.length);
        updateResultsWindowCopy(matches.length, visibleMatches.length, false);
        renderChips();

        if (results) {
          results.hidden = false;
        }

        if (emptyState) {
          emptyState.hidden = true;
        }

        clearButtons.forEach((button) => {
          button.hidden = true;
        });

        shell.classList.add('is-filtered');
        shell.classList.remove('has-active-filters');
        refreshOptionAvailability(committedState);
      };

      const closeDialog = () => {
        if (!dialog) return;
        document.documentElement.classList.remove('gs-find-snacks-dialog-open');
        document.body.classList.remove('gs-find-snacks-dialog-open');
        if (dialog.open) {
          dialog.close();
        }
        if (activeTrigger) {
          activeTrigger.focus();
        }
      };

      const openDialog = (event) => {
        if (event) {
          event.preventDefault();
          activeTrigger = event.currentTarget;
        }
        if (!dialog) return;
        syncInputsFromState();
        updateDialogSummary();
        document.documentElement.classList.add('gs-find-snacks-dialog-open');
        document.body.classList.add('gs-find-snacks-dialog-open');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      const clearAll = (hideResults) => {
        Object.keys(committedState).forEach((group) => {
          committedState[group] = [];
        });
        if (sortControl) {
          sortControl.value = 'recommended';
        }
        productWindowExpanded = false;
        syncInputsFromState();
        renderResults(true, true);
        if (hideResults && results) {
          updateUrl();
        }
        updateDialogSummary();
      };

      const loadFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        let foundFilters = false;

        params.forEach((value, param) => {
          const group = paramToGroup[param];
          if (!group) return;
          committedState[group] = value.split(',').map((item) => item.trim()).filter(Boolean);
          if (committedState[group].length > 0) {
            foundFilters = true;
          }
        });

        if (sortControl && params.get('find_sort')) {
          sortControl.value = params.get('find_sort');
        }

        syncInputsFromState();
        if (!foundFilters && (!sortControl || sortControl.value === 'recommended')) {
          syncServerRenderedResults();
          return;
        }

        renderResults(foundFilters, false);
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', openDialog);
      });

      checkboxes.forEach((input) => {
        input.addEventListener('change', updateDialogSummary);
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeDialog);
      }

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            closeDialog();
          }
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('gs-find-snacks-dialog-open');
          document.body.classList.remove('gs-find-snacks-dialog-open');
        });
      }

      if (resetButton) {
        resetButton.addEventListener('click', () => {
          clearAll(false);
        });
      }

      if (applyButton) {
        applyButton.addEventListener('click', () => {
          committedState = getStateFromInputs(checkboxes);
          productWindowExpanded = false;
          renderResults(true, true);
          closeDialog();
          if (results && !results.hidden) {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      clearButtons.forEach((button) => {
        button.addEventListener('click', () => {
          clearAll(true);
        });
      });

      if (sortControl) {
        sortControl.addEventListener('change', () => {
          productWindowExpanded = false;
          renderResults(!results.hidden, true);
        });
      }

      if (resultsViewAll) {
        resultsViewAll.addEventListener('click', () => {
          productWindowExpanded = true;
          renderResults(true, true);
        });
      }

      loadFromUrl();
    };

    const initAllShells = () => {
      document.querySelectorAll('[data-gs-find-snacks-shell]').forEach(initShell);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllShells, { once: true });
    } else {
      initAllShells();
    }

    document.addEventListener('shopify:section:load', initAllShells);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-home-social-proof"] && !Shopify.designMode) return;
  try {
    
  const socialTriggers = document.querySelectorAll('[data-gs-social-open]');

  socialTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('.gs-home-social');
      const modal = section && section.querySelector('[data-gs-social-modal]');
      const frame = modal && modal.querySelector('[data-gs-social-frame]');
      const title = modal && modal.querySelector('h3');
      const originalLink = modal && modal.querySelector('[data-gs-social-link]');
      const closeButton = modal && modal.querySelector('[data-gs-social-close]:not(.gs-home-social-modal__backdrop)');
      const embedUrl = trigger.dataset.gsEmbedUrl;
      const originalUrl = trigger.dataset.gsOriginalUrl;
      const modalTitle = trigger.dataset.gsModalTitle || 'Snack reaction';

      if (!modal || !frame || !embedUrl) {
        if (originalUrl) {
          window.open(originalUrl, '_blank', 'noopener');
        }

        return;
      }

      frame.replaceChildren();

      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = modalTitle;
      iframe.loading = 'lazy';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);

      if (title) {
        title.textContent = modalTitle;
      }

      if (originalLink) {
        if (originalUrl) {
          originalLink.href = originalUrl;
          originalLink.hidden = false;
        } else {
          originalLink.hidden = true;
        }
      }

      modal.hidden = false;
      closeButton && closeButton.focus();
    });
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-gs-social-close]');
    if (!close) return;

    const modal = close.closest('[data-gs-social-modal]');
    const frame = modal && modal.querySelector('[data-gs-social-frame]');

    if (frame) {
      frame.replaceChildren();
    }

    if (modal) {
      modal.hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-gs-social-modal]:not([hidden])').forEach((modal) => {
      const frame = modal.querySelector('[data-gs-social-frame]');
      if (frame) {
        frame.replaceChildren();
      }

      modal.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-mystery-sack-landing"] && !Shopify.designMode) return;
  try {
    
  const resetMysteryLandingInitialScroll = () => {
    const landing = document.querySelector('[data-gs-module="mystery_snack_sack_editorial"]');
    const reviewHashPattern = /^#mystery-sack-(featured-reviews|reviews)-/;
    const hasHash = window.location.hash.length > 0;

    if (!landing || (hasHash && !reviewHashPattern.test(window.location.hash))) return;

    const resetScroll = () => {
      const documentScroller = document.scrollingElement || document.documentElement;
      const desktopScroller = window.matchMedia('(min-width: 990px)').matches
        ? document.querySelector('.page-wrapper')
        : null;

      [documentScroller, desktopScroller].forEach((scroller) => {
        if (!scroller || typeof scroller.scrollTo !== 'function') return;
        scroller.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });

      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

      try {
        const currentState = typeof history.state === 'object' && history.state !== null ? history.state : {};

        if (reviewHashPattern.test(window.location.hash)) {
          history.replaceState(
            { ...currentState, scrollTop: 0 },
            '',
            `${window.location.pathname}${window.location.search}`
          );
        } else {
          history.replaceState({ ...currentState, scrollTop: 0 }, '');
        }
      } catch (_) {
        // Ignore browser history edge cases; the visible scroll reset still works.
      }
    };

    resetScroll();
    window.requestAnimationFrame(() => {
      resetScroll();
      window.requestAnimationFrame(resetScroll);
    });
  };

  resetMysteryLandingInitialScroll();
  window.addEventListener('pageshow', resetMysteryLandingInitialScroll);
  window.addEventListener('load', resetMysteryLandingInitialScroll, { once: true });

  document.querySelectorAll('[data-gs-mystery-reveal]').forEach((reveal) => {
    const range = reveal.querySelector('.gs-mystery-landing__reveal-range');
    const cueRoot = reveal.closest('.gs-mystery-landing__reveal-band');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cueTimer;

    if (!range) return;

    const clearCue = () => {
      window.clearTimeout(cueTimer);
      reveal.classList.remove('is-cueing');
      cueRoot?.classList.remove('is-cueing');
    };

    const restartCue = () => {
      if (reduceMotion || reveal.classList.contains('is-touched')) return;

      clearCue();
      void reveal.offsetWidth;
      reveal.classList.add('is-cueing');
      cueRoot?.classList.add('is-cueing');
      cueTimer = window.setTimeout(clearCue, 7800);
    };

    const markTouched = () => {
      reveal.classList.add('is-touched');
      clearCue();
    };

    const setReveal = (value) => {
      const revealValue = Number(value) || 0;
      reveal.style.setProperty('--reveal', `${revealValue}%`);
      reveal.classList.toggle('has-example-badge', revealValue >= 35);
    };

    range.addEventListener('pointerdown', markTouched);
    range.addEventListener('touchstart', markTouched, { passive: true });
    range.addEventListener('keydown', markTouched);
    range.addEventListener('input', () => {
      markTouched();
      setReveal(range.value);
    });

    setReveal(range.value || 0);

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) restartCue();
        });
      }, { threshold: 0.35 });

      observer.observe(cueRoot || reveal);
    } else {
      restartCue();
    }
  });

  document.querySelectorAll('[data-gs-mystery-review-toggle]').forEach((toggle) => {
    const feedId = toggle.getAttribute('aria-controls');
    const feed = document.getElementById(feedId);
    const label = toggle.querySelector('[data-gs-review-toggle-label]');
    const icon = toggle.querySelector('[data-gs-review-toggle-icon]');
    const fallback = toggle.parentElement?.querySelector('[data-gs-review-fallback]');

    if (!feed) return;

    const closedLabel = toggle.dataset.labelClosed || 'VIEW MORE VERIFIED REVIEWS';
    const openLabel = toggle.dataset.labelOpen || 'HIDE VERIFIED REVIEWS';

    if (fallback) {
      fallback.hidden = true;
    }

    const refreshJudgeMe = () => {
      if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') {
        window.jdgm.renderWidgets();
      } else if (window.jdgm && typeof window.jdgm.renderWidget === 'function') {
        window.jdgm.renderWidget();
      }
    };

    const setOpen = (isOpen) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      feed.hidden = !isOpen;

      if (label) {
        label.textContent = isOpen ? openLabel : closedLabel;
      }

      if (icon) {
        icon.textContent = '+';
      }

      if (isOpen) {
        window.requestAnimationFrame(refreshJudgeMe);
      } else {
        window.requestAnimationFrame(() => {
          const rect = toggle.getBoundingClientRect();

          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            toggle.scrollIntoView({ block: 'center' });
          }
        });
      }
    };

    setOpen(false);

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
      setOpen(isOpen);
      toggle.focus({ preventScroll: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-pdp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'gs_recently_viewed_products_v1';
    const availabilityStorageKey = 'gs_recently_viewed_public_products_v1';
    const maxStoredProducts = 24;
    const validationBatchSize = 4;
    const availabilityCacheTtl = 5 * 60 * 1000;
    const availabilityCache = new Map();

    const readHistory = () => {
      try {
        const value = window.localStorage.getItem(storageKey);
        const parsed = value ? JSON.parse(value) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const writeHistory = (items) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, maxStoredProducts)));
      } catch (error) {
        // Ignore private browsing or storage quota errors.
      }
    };

    const readAvailabilityCache = () => {
      try {
        const value = window.sessionStorage.getItem(availabilityStorageKey);
        const parsed = value ? JSON.parse(value) : {};
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return;

        Object.entries(parsed).forEach(([handle, entry]) => {
          if (!entry || typeof entry !== 'object') return;
          if (entry.status !== 'public' && entry.status !== 'unavailable') return;
          if (!Number.isFinite(entry.checkedAt) || Date.now() - entry.checkedAt > availabilityCacheTtl) return;
          availabilityCache.set(handle, entry);
        });
      } catch (error) {
        // Ignore private browsing or unavailable session storage.
      }
    };

    const writeAvailabilityCache = () => {
      try {
        window.sessionStorage.setItem(availabilityStorageKey, JSON.stringify(Object.fromEntries(availabilityCache)));
      } catch (error) {
        // Ignore private browsing or storage quota errors.
      }
    };

    const normalizedHandle = (handle) => {
      if (typeof handle !== 'string') return '';
      const normalized = handle.trim().toLowerCase();
      return /^[a-z0-9][a-z0-9-]*$/.test(normalized) ? normalized : '';
    };

    const publicProductStatus = async (rawHandle) => {
      const handle = normalizedHandle(rawHandle);
      if (!handle) return 'unavailable';
      const cachedEntry = availabilityCache.get(handle);
      if (cachedEntry && Date.now() - cachedEntry.checkedAt <= availabilityCacheTtl) return cachedEntry.status;

      const routesRoot = window.Shopify?.routes?.root || '/';
      const productUrl = `${routesRoot}products/${encodeURIComponent(handle)}.js`;

      try {
        const response = await window.fetch(productUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (response.ok) {
          availabilityCache.set(handle, { status: 'public', checkedAt: Date.now() });
          writeAvailabilityCache();
          return 'public';
        }

        if (response.status === 404) {
          availabilityCache.set(handle, { status: 'unavailable', checkedAt: Date.now() });
          writeAvailabilityCache();
          return 'unavailable';
        }
      } catch (error) {
        // A transient network error should not erase browser history.
      }

      return 'unknown';
    };

    const validateHistory = async (items, visibleLimit) => {
      const publicItems = [];
      const invalidHandles = new Set();

      for (let index = 0; index < items.length && publicItems.length < visibleLimit; index += validationBatchSize) {
        const batch = items.slice(index, index + validationBatchSize);
        const statuses = await Promise.all(batch.map((item) => publicProductStatus(item.handle)));

        batch.forEach((item, batchIndex) => {
          const status = statuses[batchIndex];
          if (status === 'public' && publicItems.length < visibleLimit) publicItems.push(item);
          if (status === 'unavailable') invalidHandles.add(item.handle);
        });
      }

      return {
        publicItems,
        cleanedHistory: items.filter((item) => !invalidHandles.has(item.handle)),
      };
    };

    const safeProductUrl = (url) => {
      if (typeof url !== 'string') return '#';
      return url.startsWith('/products/') ? url : '#';
    };

    const safeImageUrl = (url) => {
      if (typeof url !== 'string') return '';
      if (url.startsWith('https://') || url.startsWith('http://') || url.startsWith('//') || url.startsWith('/')) {
        return url;
      }
      return '';
    };

    const getCurrentProduct = (section) => ({
      handle: section.dataset.currentHandle || '',
      title: section.dataset.currentTitle || '',
      text: section.dataset.currentText || '',
      url: safeProductUrl(section.dataset.currentUrl || ''),
      image: safeImageUrl(section.dataset.currentImage || ''),
      price: section.dataset.currentPrice || '',
      vendor: section.dataset.currentVendor || '',
      productType: section.dataset.currentProductType || '',
      originFlag: section.dataset.currentOriginFlag || '',
      originLabel: section.dataset.currentOriginLabel || '',
    });

    const appendText = (parent, text) => {
      parent.textContent = text || '';
      return parent;
    };

    const buildCard = (item, index, section, showPrices) => {
      const cardCtaLabel = section.dataset.cardCtaLabel || 'View again';
      const url = safeProductUrl(item.url);
      const imageUrl = safeImageUrl(item.image);

      const card = document.createElement('article');
      card.className = 'gs-home-product-card gs-home-product-card--collection gs-pdp-recently-viewed__card';
      card.dataset.gsEvent = 'gs_product_card_view';
      card.dataset.gsSurface = 'pdp';
      card.dataset.gsModule = section.dataset.gsModule || 'pdp_recently_viewed';
      card.dataset.gsModuleId = section.dataset.gsModuleId || 'pdp-recently-viewed';
      card.dataset.gsPosition = String(index + 1);
      card.dataset.gsProductHandle = item.handle || '';
      card.dataset.gsBrandFamily = item.vendor || '';

      const productLink = document.createElement('a');
      productLink.className = 'gs-home-product-card__link gs-pdp-recently-viewed__product-link';
      productLink.href = url;
      productLink.setAttribute('aria-label', item.title || 'Recently viewed product');
      productLink.dataset.gsEvent = 'gs_product_card_click';
      productLink.dataset.gsSurface = 'pdp';
      productLink.dataset.gsModule = card.dataset.gsModule;
      productLink.dataset.gsModuleId = card.dataset.gsModuleId;
      productLink.dataset.gsPosition = card.dataset.gsPosition;
      productLink.dataset.gsClickTarget = 'recently_viewed_card';
      productLink.dataset.gsProductHandle = item.handle || '';

      const media = document.createElement('figure');
      media.className = 'gs-home-product-card__media gs-pdp-recently-viewed__media';

      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'gs-home-product-card__image gs-pdp-recently-viewed__image';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.alt = item.title || '';
        image.src = imageUrl;
        media.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'gs-home-product-card__placeholder gs-pdp-recently-viewed__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        media.appendChild(placeholder);
      }

      const productTypeKey = (item.productType || '').toLowerCase();
      const productIdentity = `${item.title || ''} ${item.handle || ''}`.toLowerCase();
      const suppressOriginFlag =
        productTypeKey.includes('merch') ||
        productTypeKey.includes('bundle') ||
        productTypeKey.includes('gift card') ||
        productIdentity.includes('mystery snack sack') ||
        productIdentity.includes('galactic grab bag') ||
        productIdentity.includes('420 deal') ||
        productIdentity.includes('4 for 20') ||
        productIdentity.includes('4-for-20');

      if (item.originFlag && !suppressOriginFlag) {
        const flag = document.createElement('figcaption');
        flag.className = 'gs-home-product-card__badge gs-home-product-card__badge--flag';
        flag.setAttribute('role', 'img');
        flag.setAttribute('aria-label', item.originLabel || 'Product origin');
        const flagIcon = document.createElement('span');
        flagIcon.setAttribute('aria-hidden', 'true');
        appendText(flagIcon, item.originFlag);
        flag.appendChild(flagIcon);
        media.appendChild(flag);
      }

      const body = document.createElement('div');
      body.className = 'gs-home-product-card__body gs-pdp-recently-viewed__body';

      const title = document.createElement('h3');
      appendText(title, item.title || 'Recently viewed product');
      body.appendChild(title);

      if (item.text) {
        const text = document.createElement('p');
        appendText(text, item.text);
        body.appendChild(text);
      }

      if (showPrices && item.price) {
        const price = document.createElement('span');
        price.className = 'gs-home-product-card__price gs-pdp-recently-viewed__price';
        appendText(price, item.price);
        body.appendChild(price);
      }

      const button = document.createElement('a');
      button.className = 'gs-home-product-card__quick-add-button gs-pdp-recently-viewed__button';
      button.href = url;
      button.dataset.gsEvent = 'gs_module_click';
      button.dataset.gsSurface = 'pdp';
      button.dataset.gsModule = card.dataset.gsModule;
      button.dataset.gsModuleId = card.dataset.gsModuleId;
      button.dataset.gsPosition = card.dataset.gsPosition;
      button.dataset.gsClickTarget = 'recently_viewed_cta';
      button.dataset.gsProductHandle = item.handle || '';
      appendText(button, cardCtaLabel);

      productLink.appendChild(media);
      productLink.appendChild(body);
      card.appendChild(productLink);
      card.appendChild(button);
      return card;
    };

    const initRecentlyViewed = (root = document) => {
      const sections = Array.from(root.querySelectorAll('[data-gs-recently-viewed]'));
      if (root instanceof Element && root.matches('[data-gs-recently-viewed]')) sections.unshift(root);

      sections.forEach(async (section) => {
        if (section.dataset.gsInitialized === 'true' || section.dataset.gsInitialized === 'pending') return;
        section.dataset.gsInitialized = 'pending';

        const currentProduct = getCurrentProduct(section);
        const history = readHistory().filter((item) => item && item.handle && item.handle !== currentProduct.handle);
        const seenHandles = new Set();
        const dedupedHistory = history.filter((item) => {
          if (seenHandles.has(item.handle)) return false;
          seenHandles.add(item.handle);
          return true;
        });

        const maxProducts = Number.parseInt(section.dataset.maxProducts || '4', 10);
        const visibleLimit = Number.isFinite(maxProducts) ? maxProducts : 4;
        const grid = section.querySelector('[data-gs-recently-viewed-grid]');

        if (currentProduct.handle && currentProduct.title && currentProduct.url !== '#') {
          writeHistory([currentProduct].concat(dedupedHistory));
        }

        const { publicItems, cleanedHistory } = await validateHistory(dedupedHistory, visibleLimit);

        if (grid && publicItems.length) {
          const showPrices = grid.dataset.showPrices === 'true';
          grid.replaceChildren(...publicItems.map((item, index) => buildCard(item, index, section, showPrices)));
          section.hidden = false;
          section.dispatchEvent(new CustomEvent('gs:merchandising:ready', { bubbles: true }));
        }

        if (currentProduct.handle && currentProduct.title && currentProduct.url !== '#') {
          writeHistory([currentProduct].concat(cleanedHistory));
        } else {
          writeHistory(cleanedHistory);
        }

        section.dataset.gsInitialized = 'true';
      });
    };

    readAvailabilityCache();
    initRecentlyViewed();
    document.addEventListener('DOMContentLoaded', () => initRecentlyViewed());
    document.addEventListener('shopify:section:load', (event) => initRecentlyViewed(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-pdp-recommendation-slot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffleGrid = (grid) => {
      if (grid.dataset.gsRandomized === 'true') return;
      if (grid.dataset.gsRandomizeProducts !== 'true') return;

      const visibleLimit = Number.parseInt(grid.dataset.gsVisibleProductLimit || '4', 10);
      const limitOnePerVendor = grid.dataset.gsLimitOnePerVendor === 'true';
      const cards = Array.from(grid.querySelectorAll('[data-gs-random-pool-card]'));

      if (!cards.length || !Number.isFinite(visibleLimit)) return;

      for (let index = cards.length - 1; index > 0; index -= 1) {
        const targetIndex = Math.floor(Math.random() * (index + 1));
        const currentCard = cards[index];
        cards[index] = cards[targetIndex];
        cards[targetIndex] = currentCard;
      }

      const prioritizedCards = [];
      const repeatedVendorCards = [];
      const seenVendorKeys = new Set();

      cards.forEach((card) => {
        const dedupeKey = (card.dataset.gsDedupeKey || card.dataset.gsBrandFamily || '').trim().toLowerCase();

        if (!limitOnePerVendor || !dedupeKey) {
          prioritizedCards.push(card);
          return;
        }

        if (seenVendorKeys.has(dedupeKey)) {
          repeatedVendorCards.push(card);
          return;
        }

        seenVendorKeys.add(dedupeKey);
        prioritizedCards.push(card);
      });

      prioritizedCards.concat(repeatedVendorCards).forEach((card, index) => {
        const nextPosition = String(index + 1);

        card.hidden = index >= visibleLimit;
        card.dataset.gsPosition = nextPosition;
        card.querySelectorAll('[data-gs-position]').forEach((trackedElement) => {
          trackedElement.dataset.gsPosition = nextPosition;
        });
        grid.appendChild(card);
      });

      grid.dataset.gsRandomized = 'true';
      grid.dispatchEvent(new CustomEvent('gs:recommendation-rows-ready', { bubbles: true }));
    };

    const shuffleRecommendationRows = (root = document) => {
      root
        .querySelectorAll('.gs-pdp-reco-slot__grid[data-gs-randomize-products="true"]')
        .forEach(shuffleGrid);
    };

    shuffleRecommendationRows();
    document.addEventListener('DOMContentLoaded', () => shuffleRecommendationRows());
    document.addEventListener('shopify:section:load', (event) => shuffleRecommendationRows(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-reward-redemption"] && !Shopify.designMode) return;
  try {
    
  (async () => {
    const page = document.querySelector('[data-gs-reward-page]');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';
    const messages = page.querySelector('[data-reward-messages]').dataset;
    const form = page.querySelector('[data-reward-code-form]');
    const input = form.querySelector('input[name="reward_code"]');
    const applyButton = form.querySelector('button');
    const status = page.querySelector('[data-reward-status]');
    const host = document.querySelector('[data-gs-picker-sort-mode="treasure_box"]');
    if (!host) return;
    const { inspectRewardCart, rewardMatchesSelection, refreshRewardDrawer, rewardViewState, rewardGateState, reconcileRewardProtection, acquireRewardCartLock, mergeRewardCodes, rewardRemovalNotice, rewardCompletionState, rewardProgressState, createRewardRefreshQueue } = await import(page.dataset.policyUrl);
    const { validateRewardCode } = await import(page.dataset.gateUrl);
    let validatedCode = '';
    let codeEditing = false;
    let checkingCode = false;
    let gateVersion = 0;
    let gateError = '';
    let latestCart = null;
    let redeeming = false;
    let rejected = false;
    let uncertain = false;
    let notice = '';
    let savedCode = '';
    let operation = '';
    let updated = false;
    let editing = false;
    let failedUpdate = false;
    let failedAdd = false;
    let pendingChangeFocus = false;
    let activeTransaction = null;
    const finishTransaction = transaction => {
      transaction.release?.();
      transaction.release = null;
      if (activeTransaction === transaction) { activeTransaction = null; redeeming = false; operation = ''; }
    };
    let refreshVersion = 0;
    const rememberPending = pending => {
      sessionStorage.setItem('gs-reward-pending', String(pending));
      document.dispatchEvent(new Event('gs:reward-state'));
    };
    const startJourney = () => {
      sessionStorage.setItem('gs-reward-v2-started', 'true');
      rememberPending(true);
    };
    let codeRequest = null;
    let preparingAdd = false;
    let forwardingAdd = false;
    let removingUnsafeReward = false;
    const sessionCodeKey = 'gs-reward-v2-code';
    const sessionDraftKey = 'gs-reward-v2-code-draft';
    const sessionPickKey = 'gs-reward-pick';
    const setStatus = (text, state = 'pending') => {
      if (text === messages.error) uncertain = uncertain || (activeTransaction?.replacing ? 'update' : true);
      renderAction();
    };
    const cartRequest = async (suffix, options = {}) => {
      const response = await fetch(`${page.dataset.cartUrl}${suffix}`, {
        cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(20000), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...options,
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };
    const inspection = cart => inspectRewardCart(cart, page.dataset.variant, savedCode);
    const rewardLines = cart => inspection(cart).rewards;
    const codeIsApplicable = cart => inspection(cart).codeApplies;
    const hasSelection = () => Boolean(host.querySelector('.biscuits-bundle-item.biscuits--active'));
    const currentFingerprint = () => hasSelection() ? host.querySelector('input[name*="[properties][_selectedItems]"]')?.value || '' : '';
    const confirmedSelection = () => latestCart && inspection(latestCart).confirmed &&
      rewardMatchesSelection(inspection(latestCart).rewards, currentFingerprint());
    const selectedName = () => host.querySelector('.biscuits--active .biscuits-bundle-item__product-title')?.textContent.trim() || '';
    const cartCard = () => {
      const line = latestCart && rewardLines(latestCart)[0];
      let id;
      try { id = JSON.parse(line?.properties?._selectedItems || '[]')[0]?.i; } catch {}
      return [...host.querySelectorAll('.biscuits-bundle-item')].find(c => c.dataset.biscuitsSelectedVariantId === String(id));
    };
    const cartName = () => cartCard()?.querySelector('.biscuits-bundle-item__product-title')?.textContent.trim() ||
      document.querySelector('[data-gs-reward-name]')?.dataset.gsRewardName || latestCart && rewardLines(latestCart)[0]?.product_title || '';
    const focusCompletion = () => {
      if (page.dataset.rewardComplete !== 'true') return;
      const title = page.querySelector('[data-reward-completion-title]');
      title.focus({preventScroll:true});
      page.closest('.page-wrapper')?.scrollTo({top:0,left:0,behavior:'instant'});
      window.scrollTo({top:0,left:0,behavior:'instant'});
    };
    const renderAction = () => {
      page.dataset.verifying = String(redeeming || preparingAdd);
      const action = host.querySelector('[data-reward-action]');
      const unavailable = host.querySelector('biscuits-bundle-form')?.dataset.gsBiscuitsInventoryIssue === 'true';
      const state = rewardViewState({ cart: latestCart, variant: page.dataset.variant,
        code: input.value.trim(), savedCode, fingerprint: currentFingerprint(), selected: hasSelection(), validated: Boolean(validatedCode) && validatedCode === input.value.trim().toUpperCase(), checkingCode, gateError,
        busy: redeeming || preparingAdd || Boolean(codeRequest), rejected, uncertain, unavailable, notice, operation, updated, editing, failedUpdate, failedAdd });
      const gate = rewardGateState({ code: input.value.trim(), savedCode, validated: Boolean(validatedCode) && validatedCode === input.value.trim().toUpperCase(), checkingCode });
      const free = Boolean(latestCart && inspection(latestCart).financiallyFree);
      const same = free && rewardMatchesSelection(rewardLines(latestCart), currentFingerprint());
      const codeFeedback = Boolean(gateError || rejected || checkingCode || uncertain);
      const text = codeFeedback ? messages[state.message] : validatedCode && validatedCode === input.value.trim().toUpperCase() ? messages.unlocked : '';
      if (status.textContent !== text) status.textContent = text;
      status.dataset.state = codeFeedback ? state.tone || 'pending' : 'confirmed';
      status.hidden = !text;
      const announcement = page.querySelector('[data-reward-announcement]');
      const announceText = !codeFeedback && (redeeming || preparingAdd || state.tone === 'success' || notice) ? messages[state.message] : '';
      const quiet = messages[state.message] && notice === 'removedItem' && !gate.locked ? messages.removedItemReady : announceText;
      if (quiet && announcement.textContent !== quiet) announcement.textContent = quiet;
      input.setAttribute('aria-invalid', String(rejected || ['gateRejected','gateExpired'].includes(gateError)));
      host.querySelectorAll('[data-reward-step-title]').forEach(element => {
        if (element.textContent !== messages[state.heading]) element.textContent = messages[state.heading];
        const step = element.previousElementSibling;
        step.hidden = state.tone === 'error';
        const number = ['code','save','retry'].includes(state.intent) ? '1' : state.intent === 'choose' ? '2' : '3';
        if (step.textContent !== number) step.textContent = number;
      });
      const locked = gate.locked || rejected || uncertain || Boolean(gateError);
      host.dataset.rewardLocked = String(locked);
      page.querySelector('[data-reward-count]').hidden = locked;
      host.querySelectorAll('.biscuits-bundle-body').forEach(body => { body.inert = locked || redeeming || preparingAdd; });
      const ready = page.querySelector('[data-reward-ready]');
      ready.hidden = locked;
      const readyText = messages[notice === 'removedItem' ? 'removedItemReady' : free ? 'afterSuccess' : 'gateReadyBody'];
      if (ready.textContent !== readyText) ready.textContent = readyText;
      const complete = rewardCompletionState({cart:latestCart, variant:page.dataset.variant, editing, busy:redeeming || preparingAdd, uncertain});
      const wasComplete = page.dataset.rewardComplete === 'true';
      page.dataset.rewardComplete = String(complete);
      page.querySelector('[data-reward-completion]').hidden = !complete;
      const codeConfirmed = !codeEditing && !locked && Boolean(validatedCode) && validatedCode === input.value.trim().toUpperCase();
      const codeSummary = page.querySelector('[data-reward-code-summary]');
      codeSummary.hidden = !codeConfirmed;
      form.hidden = codeConfirmed;
      page.querySelector('[data-reward-confirmed-code]').textContent = codeConfirmed ? validatedCode : '';
      page.querySelector('.gs-reward__code-card').dataset.confirmed = String(codeConfirmed);
      if (codeConfirmed && !codeFeedback) status.hidden = true;
      const progress = rewardProgressState({complete, validated:codeConfirmed, locked, selected:hasSelection()});
      page.querySelectorAll('[data-reward-progress]').forEach(step => {
        const number = Number(step.dataset.rewardProgress);
        step.dataset.state = number <= progress.completed ? 'done' : number === progress.current ? 'current' : 'pending';
        if (step.dataset.state === 'current') step.setAttribute('aria-current','step');
        else step.removeAttribute('aria-current');
        step.querySelector('[data-reward-progress-done]').hidden = step.dataset.state !== 'done';
      });
      host.inert = complete;
      const intro = page.querySelector('[data-reward-intro]');
      const introText = complete ? messages.completionIntro : messages.intro;
      if (intro.textContent !== introText) intro.textContent = introText;
      const price = latestCart && rewardLines(latestCart)[0]?.final_line_price;
      page.querySelector('[data-reward-completion-price]').textContent = complete && Number(price) === 0 ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:page.dataset.currency}).format(Number(price)/100) : '';
      const completionName = page.querySelector('[data-reward-completion-name]');
      if (completionName.textContent !== cartName()) completionName.textContent = cartName();
      const completionImage = page.querySelector('[data-reward-completion-image]');
      const imageSource = cartCard()?.querySelector('img.active')?.src || cartCard()?.querySelector('img')?.src || document.querySelector('[data-gs-reward-name] .cart-items__media-image')?.src;
      completionImage.hidden = !imageSource;
      if (imageSource && completionImage.src !== imageSource) completionImage.src = imageSource;
      if (complete && !wasComplete && !document.querySelector('#cart-drawer[open]')) requestAnimationFrame(focusCompletion);
      const lock = host.querySelector('.gs-reward__picker-lock');
      if (lock) {
        lock.hidden = !locked;
        const existingOnly = state.intent === 'cart';
        const title = messages[existingOnly ? 'gateStartTitle' : state.heading] || messages.gateStartTitle;
        const body = checkingCode ? '' : messages[existingOnly ? 'gateCodeBody' : state.compact || state.message];
        lock.querySelector('[data-reward-lock-copy]').hidden = !body;
        if (lock.querySelector('strong').textContent !== title) lock.querySelector('strong').textContent = title;
        lock.setAttribute('aria-label', title);
        if (lock.querySelector('[data-reward-lock-copy]').textContent !== body) lock.querySelector('[data-reward-lock-copy]').textContent = body;
        const button = lock.querySelector('button');
        button.dataset.intent = existingOnly ? 'code' : state.intent;
        button.disabled = state.intent === 'wait';
        const lockLabel = messages[existingOnly ? 'enterCode' : state.label];
        if (button.textContent !== lockLabel) button.textContent = lockLabel;
      }
      page.dataset.rewardStep = locked ? '1' : !hasSelection() ? '2' : '3';
      page.querySelector('.gs-reward__code-card').dataset.current = String(page.dataset.rewardStep === '1');
      page.querySelector('.gs-reward__shelf-heading').dataset.current = String(page.dataset.rewardStep === '2');
      if (sticky) sticky.dataset.rewardTone = state.tone || 'pending';
      document.dispatchEvent(new CustomEvent('gs:reward-view', { detail: { cart:latestCart, free, selected:hasSelection(), same, notice, uncertain, blocked:locked, pendingName:selectedName(), currentName:cartName(), intent:state.intent } }));
      if (!action) return;
      action.dataset.intent = state.intent;
      action.disabled = state.intent === 'wait' || (state.intent === 'add' && Boolean(host.querySelector('biscuits-bundle-form button[data-add-to-cart]')?.disabled));
      if (action.textContent !== messages[state.label]) action.textContent = messages[state.label];
      host.querySelectorAll('[data-reward-note]').forEach(element => {
        const note = ['code','save','retry','reconcile'].includes(state.intent) || ['pending','success','updatedStatus','gateCodeBody','gateDraftBody'].includes(state.message) ? '' : notice === 'removedItem' && !gate.locked ? messages.removedItemReady : messages[state.compact || state.message];
        if (element.textContent !== note) element.textContent = note;
        element.hidden = !note;
      });
      host.querySelectorAll('.gs-reward__selection a').forEach(a => { a.hidden = state.intent !== 'cart'; });
      const nextTitle = selectedName() || messages.choosePrompt;
      host.querySelectorAll('[data-reward-pick]').forEach(pick => { if (pick.textContent !== nextTitle) pick.textContent = nextTitle; });
    };
    const setCartEligibility = cart => { latestCart = cart; renderAction(); };
    const showCartState = cart => {
      setCartEligibility(cart);
      rememberPending(!confirmedSelection());
      applyButton.textContent = validatedCode && validatedCode === input.value.trim().toUpperCase() ? messages.codeConfirmed : messages.apply;
    };
    const dispatchCartUpdate = async (cart, action = 'remove', sections) => {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'product', lines: [], promise: deferred.promise }));
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: false, itemCount: cart.item_count, items: cart.items, source: 'reward-refresh', sections },
      });
    };
    const removeReward = async (cart, message) => {
      if (removingUnsafeReward || !rewardLines(cart).length) return cart;
      removingUnsafeReward = true;
      try {
        cart = await cartRequest('.js');
        if (inspection(cart).financiallyFree || !rewardLines(cart).length) { showCartState(cart); return cart; }
        const updates = Object.fromEntries(rewardLines(cart).map(item => [item.key, 0]));
        await cartRequest('/update.js', { method: 'POST', body: JSON.stringify({ updates }) });
        const result = await reconcileRewardProtection(page.dataset.cartUrl, page.dataset.variant);
        if (rewardLines(result).length) throw new Error('Reward removal not confirmed');
        delete host.querySelector('[data-gs-biscuits-sticky]')?.dataset.postAdd;
        await dispatchCartUpdate(result, 'remove', await refreshRewardDrawer());
        setCartEligibility(result);
        rejected = false;
        validatedCode = '';
        uncertain = false;
        notice = notice || 'removedSafety';
        sessionStorage.setItem('gs-reward-notice', notice);
        rememberPending(true);
        setStatus(message, 'error');
        applyButton.textContent = validatedCode === input.value.trim().toUpperCase() && validatedCode ? messages.codeConfirmed : messages.apply;
        return result;
      } catch (error) {
        uncertain = 'cleanup';
        throw error;
      } finally {
        removingUnsafeReward = false;
      }
    };
    const verifyReward = async (cart, attempting = redeeming) => {
      if (!cart) return null;
      const transition = rewardRemovalNotice(latestCart, cart, page.dataset.variant, attempting || preparingAdd);
      if (transition) { notice = transition; sessionStorage.setItem('gs-reward-notice', notice); document.dispatchEvent(new CustomEvent('gs:reward-removed',{detail:transition})); }
      if (inspection(cart).financiallyFree) { notice = ''; sessionStorage.removeItem('gs-reward-notice'); }
      setCartEligibility(cart);
      const rewards = rewardLines(cart);
      if (!rewards.length) {
        if (attempting) {
          failedAdd = true;
          rememberPending(true);
          renderAction();
        } else showCartState(cart);
        return cart;
      }
      const rewardQuantity = rewards.reduce((total, item) => total + item.quantity, 0);
      if (rewardQuantity !== 1 || rewards.some(item => Number(item.final_line_price) !== 0)) {
        return removeReward(cart, messages.removedUnconfirmed);
      }
      if (attempting && !codeIsApplicable(cart)) { rejected = true; rememberPending(true); renderAction(); return cart; }
      showCartState(cart);
      return cart;
    };
    const applyCode = () => {
      if (codeRequest) return codeRequest;
      if (!savedCode) return Promise.resolve(null);
      if (savedCode.includes(',')) {
        rejected = true;
        return cartRequest('.js').then(cart => {
          setCartEligibility(cart);
          setStatus(messages.singleCode, 'error');
          return null;
        });
      }
      const requestedCode = savedCode;
      codeRequest = (async () => {
        applyButton.disabled = true;
        input.disabled = true;
        applyButton.textContent = messages.checking;
        let deferred;
        try {
          const cart = await cartRequest('.js');
          const previousCode = sessionStorage.getItem('gs-reward-submitted-code')?.toUpperCase();
          const codes = mergeRewardCodes(cart, requestedCode, previousCode, page.dataset.variant);
          const { CartDiscountUpdateEvent } = await import('@shopify/events');
          deferred = CartDiscountUpdateEvent.createPromise();
          form.dispatchEvent(new CartDiscountUpdateEvent({ discountCodes: codes.map(code => ({ code })), promise: deferred.promise }));
          const result = await cartRequest('/update.js', { method: 'POST', body: JSON.stringify({ discount: codes.join(',') }) });
          sessionStorage.setItem('gs-reward-submitted-code', requestedCode);
          deferred.resolve({ cart: CartDiscountUpdateEvent.createCartFromAjaxResponse(result) });
          showCartState(result);
          return result;
        } catch (error) {
          deferred?.reject(error);
          setStatus(messages.error, 'error');
          applyButton.textContent = validatedCode === input.value.trim().toUpperCase() && validatedCode ? messages.codeConfirmed : messages.apply;
          return null;
        } finally {
          codeRequest = null;
          applyButton.disabled = false;
          input.disabled = false;
          renderAction();
        }
      })();
      return codeRequest;
    };
    const checkCode = async () => {
      const requested = input.value.trim().toUpperCase();
      const version = ++gateVersion;
      validatedCode = '';
      gateError = '';
      rejected = false;
      uncertain = false;
      if (!requested || requested.includes(',')) { rejected = requested.includes(','); renderAction(); return false; }
      checkingCode = true;
      applyButton.disabled = true;
      renderAction();
      try {
        const result = await validateRewardCode({ host, page, code: requested });
        if (version !== gateVersion || input.value.trim().toUpperCase() !== requested) return false;
        if (result === 'valid') {
          validatedCode = requested;
          codeEditing = false;
          page.querySelector('[data-reward-announcement]').textContent = messages.unlocked;
          savedCode = requested;
          sessionStorage.setItem(sessionCodeKey, savedCode);
          sessionStorage.setItem(sessionDraftKey, input.value.trim());
          notice = '';
          sessionStorage.removeItem('gs-reward-notice');
          startJourney();
          return true;
        }
        gateError = result === 'expired' ? 'gateExpired' : result === 'rejected' ? 'gateRejected' : result === 'no-stock' ? 'allUnavailable' : 'gateUnavailable';
        return false;
      } catch {
        if (version === gateVersion) gateError = 'gateUnavailable';
        return false;
      } finally {
        if (version === gateVersion) {
          checkingCode = false;
          applyButton.disabled = false;
          applyButton.textContent = validatedCode ? messages.codeConfirmed : messages.apply;
          renderAction();
          if (pendingChangeFocus && validatedCode) focusPicker();
        }
      }
    };
    const submitCode = async event => {
      event.preventDefault();
      if (preparingAdd || redeeming || checkingCode) return;
      input.value = input.value.trim();
      input.setCustomValidity(!input.value ? messages.blankCode : input.value.includes(',') ? messages.singleCode : '');
      if (!input.reportValidity()) { rejected = input.value.includes(','); renderAction(); return; }
      await checkCode();
      refreshCart(false);
    };
    applyButton.addEventListener('click', submitCode);
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') submitCode(event);
    });
    input.addEventListener('input', () => {
      input.setCustomValidity('');
      page.querySelector('[data-reward-announcement]').textContent = '';
      editing = true;
      codeEditing = true;
      gateVersion++;
      validatedCode = '';
      gateError = '';
      checkingCode = false;
      applyButton.disabled = false;
      rejected = false;
      uncertain = false;
      notice = '';
      failedAdd = false;
      sessionStorage.removeItem('gs-reward-notice');
      sessionStorage.setItem(sessionDraftKey, input.value.trim());
      rememberPending(true);
      applyButton.textContent = validatedCode === input.value.trim().toUpperCase() && validatedCode ? messages.codeConfirmed : messages.apply;
      setStatus(messages.edited);
    });
    const linkedCode = new URL(window.location.href).searchParams.get('reward_code');
    savedCode = linkedCode?.slice(0, 100).trim() || sessionStorage.getItem(sessionCodeKey) || '';
    const storedDraft = sessionStorage.getItem(sessionDraftKey);
    input.value = linkedCode !== null ? savedCode : storedDraft ?? savedCode;
    if (linkedCode !== null) {
      sessionStorage.setItem(sessionCodeKey, savedCode);
      sessionStorage.setItem(sessionDraftKey, savedCode);
      if (savedCode) startJourney();
    }
    const beginRedemption = async button => {
      if (!button || !host.contains(button)) return;
      if (preparingAdd || redeeming) return;
      if (!input.value.trim()) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
        input.reportValidity();
        setStatus(messages.edited);
        return;
      }
      if (!input.reportValidity()) {
        setStatus(messages.singleCode, 'error');
        input.focus();
        return;
      }
      refreshVersion++;
      preparingAdd = true;
      rejected = false;
      uncertain = false;
      notice = '';
      sessionStorage.removeItem('gs-reward-notice');
      failedUpdate = false;
      failedAdd = false;
      operation = latestCart && inspection(latestCart).financiallyFree ? 'updating' : 'adding';
      renderAction();
      const transaction = { id: crypto.randomUUID(), release: null, replacing: operation === 'updating' };
      activeTransaction = transaction;
      try {
        transaction.release = await acquireRewardCartLock();
        const currentCart = await cartRequest('.js');
        setCartEligibility(currentCart);
        if (!await checkCode()) return;
        const cart = await applyCode();
        const bundleForm = button.closest('biscuits-bundle-form') || host.querySelector('biscuits-bundle-form');
        if (!cart) return;
        if (!button.isConnected || !bundleForm || bundleForm.querySelector('button[data-add-to-cart]')?.disabled || bundleForm.dataset.gsBiscuitsInventoryIssue === 'true') { failedAdd = true; return; }
        redeeming = true;
        bundleForm.dataset.gsRewardAttempt = transaction.id;
        renderAction();
        forwardingAdd = true;
        button.click();
      } catch {
        setStatus(messages.error, 'error');
      } finally {
        forwardingAdd = false;
        preparingAdd = false;
        if (!redeeming && activeTransaction === transaction) finishTransaction(transaction);
        renderAction();
      }
    };
    window.addEventListener('click', event => {
      const button = event.target instanceof Element ? event.target.closest('[data-gs-biscuits-sticky-button], biscuits-bundle-form button[data-add-to-cart]') : null;
      if (!button || !host.contains(button) || forwardingAdd || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      beginRedemption(button);
    }, {capture:true});
    const focusCode = () => {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      input.focus({ preventScroll: true });
    };
    page.querySelector('[data-reward-edit-code]').addEventListener('click', () => {
      if (preparingAdd || redeeming || checkingCode) return;
      codeEditing = true;
      editing = true;
      gateVersion++;
      validatedCode = '';
      gateError = '';
      rejected = false;
      uncertain = false;
      failedAdd = false;
      notice = '';
      sessionStorage.removeItem('gs-reward-notice');
      input.setCustomValidity('');
      applyButton.textContent = messages.apply;
      renderAction();
      focusCode();
    });
    const pickerBody = host.querySelector('.gs-biscuits-app-host__inner');
    pickerBody?.prepend(page.querySelector('[data-reward-lock-template]').content.cloneNode(true));
    host.querySelector('[data-reward-unlock]')?.addEventListener('click', event => {
      const intent = event.currentTarget.dataset.intent;
      if (intent === 'save') submitCode(event);
      else if (intent === 'reconcile') { document.querySelector('button[aria-controls="cart-drawer"]')?.click(); refreshCart(true, true); }
      else if (intent === 'retry') checkCode().then(() => refreshCart(true));
      else if (intent === 'cart') document.querySelector('button[aria-controls="cart-drawer"]')?.click();
      else if (intent === 'help') window.location.href = page.querySelector('[data-reward-help]')?.href || '/pages/contact';
      else focusCode();
    });
    page.querySelector('[data-reward-view-cart]').addEventListener('click', () => document.querySelector('button[aria-controls="cart-drawer"]')?.click());
    const focusPicker = () => {
      pendingChangeFocus = false;
      requestAnimationFrame(() => {
        if (host.dataset.rewardLocked === 'true' || page.dataset.rewardComplete === 'true') return;
        page.querySelector('.gs-reward__shelf-heading').scrollIntoView({block:'start'});
        const target = host.querySelector('.biscuits--active input[type="checkbox"], input[type="checkbox"]') || page.querySelector('.gs-reward__shelf-heading h2');
        target?.focus({preventScroll:true});
      });
    };
    const beginChange = async () => {
      editing = true;
      renderAction();
      pendingChangeFocus = true;
      if (validatedCode && validatedCode === input.value.trim().toUpperCase()) { focusPicker(); return; }
      if (input.value.trim() && input.value.trim().toUpperCase() === savedCode.toUpperCase()) {
        await Promise.all(['biscuits-bundle-product','biscuits-bundle-form'].map(name=>customElements.whenDefined(name)));
        if (!checkingCode) await checkCode();
        if (validatedCode) { focusPicker(); return; }
        if (checkingCode) return;
      }
      pendingChangeFocus = false;
      focusCode();
    };
    page.querySelector('[data-reward-change]').addEventListener('click', beginChange);
    document.addEventListener('gs:reward-continue', event => {
      if (event.detail?.intent === 'reconcile') { refreshCart(true, true); return; }
      if (event.detail?.intent === 'change') { beginChange(); return; }
      const intent = host.querySelector('[data-reward-action]')?.dataset.intent;
      if (intent === 'code' || intent === 'save' || !validatedCode) focusCode();
      else if (!currentFingerprint()) {
        page.querySelector('.gs-reward__shelf-heading').scrollIntoView({ behavior: 'smooth', block: 'center' });
        host.querySelector('input:not([disabled])[type="checkbox"]')?.focus({ preventScroll: true });
      } else { const target = host.querySelector('[data-reward-action]'); target?.scrollIntoView({block:'nearest'}); target?.focus(); }
    });
    const summaryTemplate = page.querySelector('[data-reward-summary-template]');
    const sticky = host.querySelector('[data-gs-biscuits-sticky]');
    sticky?.querySelector('.gs-biscuits-sticky__inner')?.prepend(summaryTemplate.content.cloneNode(true));
    const action = document.createElement('button');
    action.type = 'button';
    action.className = 'gs-reward__action';
    action.dataset.rewardAction = '';
    const pendingNote = sticky?.querySelector('[data-reward-note]');
    if (pendingNote) action.setAttribute('aria-describedby',pendingNote.id);
    sticky?.querySelector('.gs-biscuits-sticky__inner')?.append(action);
    action.addEventListener('click', event => {
      if (action.dataset.intent === 'code') {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      } else if (action.dataset.intent === 'save') {
        submitCode(event);

      } else if (action.dataset.intent === 'cart') {
        document.querySelector('button[aria-controls="cart-drawer"]')?.click();
      } else if (action.dataset.intent === 'reconcile') {
        document.querySelector('button[aria-controls="cart-drawer"]')?.click();
        refreshCart(true, true);
      } else if (action.dataset.intent === 'retry') {
        checkCode().then(() => refreshCart(true));
      } else if (action.dataset.intent === 'help') {
        window.location.href = '/pages/contact';
      } else if (action.dataset.intent === 'choose') {
        host.querySelector('input:not([disabled])[type="checkbox"]')?.focus();
      } else if (action.dataset.intent === 'add') {
        // The native bridge remains responsible for Biscuits; its optimistic success UI is hidden.
        delete sticky.dataset.postAdd;
        beginRedemption(host.querySelector('biscuits-bundle-form button[data-add-to-cart]'));
      }
    });
    renderAction();
    const updateBarSpace = () => {
      const preview = document.querySelector('#PBarNextFrame');
      const previewRect = preview?.getBoundingClientRect();
      const previewHeight = previewRect?.height > 0 ? Math.max(0, Math.min(64, previewRect.height, window.innerHeight - previewRect.top)) : 0;
      document.body.style.setProperty('--gs-reward-preview-offset', `${previewHeight}px`);
      const height = sticky?.dataset.rewardSelected === 'true' ? sticky.getBoundingClientRect().height : 0;
      document.body.style.setProperty('--gs-reward-bar-space', `${height + (height ? previewHeight : 0)}px`);
    };
    const sizeObserver = new ResizeObserver(updateBarSpace);
    if (sticky) sizeObserver.observe(sticky);
    const observePreview = () => {
      const preview = document.querySelector('#PBarNextFrame');
      if (preview) sizeObserver.observe(preview);
      updateBarSpace();
    };
    new MutationObserver(observePreview).observe(document.body, { childList: true });
    window.addEventListener('resize', updateBarSpace, { passive: true });
    observePreview();
    let lastSelection;
    let restoredPick = false;
    const syncSelection = () => {
      host.querySelectorAll('.biscuits-bundle-totals, .biscuits-bundle-add-to-cart__container').forEach(element => {
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      });
      host.querySelectorAll('.biscuits-bundle-product-notification').forEach(element => { element.setAttribute('aria-live','off'); element.setAttribute('aria-hidden','true'); });
      host.querySelectorAll('[role="group"][tabindex="0"]').forEach(element => { element.tabIndex = -1; });
      const cards = [...host.querySelectorAll('.biscuits-bundle-item')];
      let selected = null;
      for (const card of cards) {
        let cta = card.querySelector('.gs-reward__card-cta');
        if (!cta) {
          cta = document.createElement('span');
          cta.className = 'gs-reward__card-cta';
          cta.setAttribute('aria-hidden', 'true');
          card.querySelector('.biscuits-bundle-item__details-group')?.append(cta);
        }
        const active = card.classList.contains('biscuits--active');
        const isCommitted = active && latestCart && inspection(latestCart).financiallyFree && rewardMatchesSelection(rewardLines(latestCart), currentFingerprint());
        const label = isCommitted ? messages.inCart : active ? messages.chosen : messages.choose;
        if (cta.textContent !== label) cta.textContent = label;
        if (active) selected = card;
      }
      if (!restoredPick && cards.length && customElements.get('biscuits-bundle-product') && customElements.get('biscuits-bundle-form')) {
        restoredPick = true;
        const savedHandle = sessionStorage.getItem(sessionPickKey);
        const savedCard = cards.find(card => card.dataset.biscuitsHandle === savedHandle);
        if (!selected && savedCard) {
          savedCard.querySelector('.biscuits-bundle-item__container-group')?.click();
          return;
        }
      }
      const count = page.querySelector('[data-reward-count]');
      const nextCount = selected ? messages.one : messages.none;
      if (count.textContent !== nextCount) count.textContent = nextCount;
      const title = selected?.querySelector('.biscuits-bundle-item__product-title')?.textContent.trim();
      const selection = selected?.dataset.biscuitsHandle || '';
      if (lastSelection !== undefined && selection !== lastSelection) {
        const sticky = host.querySelector('[data-gs-biscuits-sticky]');
        if (sticky?.dataset.postAdd === 'true') {
          delete sticky.dataset.postAdd;
          host.querySelector('biscuits-bundle-form')?.dispatchEvent(new Event('change', { bubbles: true }));
          renderAction();
          applyButton.textContent = validatedCode === input.value.trim().toUpperCase() && validatedCode ? messages.codeConfirmed : messages.apply;
        }
      }
      if (selection && lastSelection !== undefined && selection !== lastSelection) {
        failedUpdate = false;
        failedAdd = false;
        const currentFree = latestCart && inspection(latestCart).financiallyFree;
        page.querySelector('[data-reward-announcement]').textContent = messages[currentFree ? 'pendingAnnouncement' : 'selectedAnnouncement'].replace('[name]', title || '');
        notice = '';
        sessionStorage.removeItem('gs-reward-notice');
        rememberPending(true);
        if (latestCart && inspection(latestCart).confirmed && input.value.trim().toUpperCase() === savedCode) showCartState(latestCart);
      }
      lastSelection = selection;
      if (selection) {
        sessionStorage.setItem(sessionPickKey, selection);
        sessionStorage.setItem('gs-reward-pick-name', title || '');
        sessionStorage.setItem('gs-reward-fingerprint', currentFingerprint());
      } else if (restoredPick) {
        sessionStorage.removeItem(sessionPickKey);
        sessionStorage.removeItem('gs-reward-pick-name');
        sessionStorage.removeItem('gs-reward-fingerprint');
      }
      if (sticky) sticky.dataset.rewardSelected = String(Boolean(selected));
      const source = selected?.querySelector('img.active')?.src;
      host.querySelectorAll('.gs-reward__selection img').forEach(image => {
        image.hidden = !source;
        if (source && image.src !== source) image.src = source;
      });
      renderAction();
      updateBarSpace();
    };
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; syncSelection(); });
    });
    observer.observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-checked', 'src', 'disabled', 'data-gs-biscuits-inventory-issue'] });
    syncSelection();
    Promise.all(['biscuits-bundle-product', 'biscuits-bundle-form'].map(name => customElements.whenDefined(name)))
      .then(() => requestAnimationFrame(() => { syncSelection(); if (input.value.trim() && !checkingCode && !validatedCode) checkCode(); }));
    document.addEventListener('gs:biscuits-cart-settled', async event => {
      if (!host.contains(event.target) || !savedCode) return;
      const transaction = activeTransaction;
      // A late notification may belong to an expired attempt. It must never release
      // a newer attempt's lock or apply its code outside that transaction.
      if (!transaction || event.detail?.rewardAttempt !== transaction.id) {
        refreshCart(true);
        return;
      }
      try {
        operation = 'verifying';
        renderAction();
        const cart = event.detail?.succeeded ? await applyCode() : await cartRequest('.js');
        await verifyReward(cart || await cartRequest('.js'), Boolean(event.detail?.succeeded));
        // A failed/uncertain add is not evidence of a bad reward code.
        if (!event.detail?.succeeded && !confirmedSelection()) {
          const unknown = event.detail?.outcome !== 'failed';
          failedUpdate = !unknown && Boolean(transaction.replacing && latestCart && inspection(latestCart).financiallyFree);
          failedAdd = !unknown && !transaction.replacing && !rewardLines(latestCart).length;
          uncertain = !failedUpdate && !failedAdd && (transaction.replacing ? 'update' : true);
        }
        if (confirmedSelection()) { updated = transaction.replacing; notice = ''; uncertain = false; editing = false; }
        if (rejected && !document.querySelector('#cart-drawer[open]')) {
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          input.focus({ preventScroll: true });
        }
      } catch {
        uncertain = transaction.replacing ? 'update' : true;
        setStatus(messages.error, 'error');
      } finally {
        finishTransaction(transaction);
        renderAction();
        if (page.dataset.rewardComplete === 'true') { await document.querySelector('#cart-drawer')?.close(); focusCompletion(); }
        document.dispatchEvent(new Event('gs:reward-verified'));
      }
    });
    const refreshCart = createRewardRefreshQueue(async (renderDrawer = false, reconcile = false) => {
      const version = ++refreshVersion;
      if (redeeming || preparingAdd || removingUnsafeReward) return;
      const release = await acquireRewardCartLock();
      try {
        if (version !== refreshVersion || redeeming || preparingAdd) return;
        const cart = await cartRequest('.js');
        if (version !== refreshVersion || redeeming || preparingAdd) return;
        await verifyReward(cart);
        if (reconcile) { uncertain = false; rejected = false; failedAdd = !rewardLines(latestCart).length && hasSelection(); }
        if (version !== refreshVersion) return;
        if (renderDrawer) await dispatchCartUpdate(latestCart, 'change', await refreshRewardDrawer());
        renderAction();
      } catch { if (version === refreshVersion) setStatus(messages.error, 'error'); }
      finally { release(); }
    });
    document.addEventListener('gs:reward-cart-refresh', () => refreshCart(true));
    window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(true); });
    window.addEventListener('focus', () => refreshCart(true));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart(true); });
    import('@shopify/events').then(({ StandardEvents }) => {
      const onCartChange = event => {
        if (removingUnsafeReward || event.target === form || redeeming || preparingAdd) return;
        event.promise?.then(() => refreshCart(false)).catch(() => setStatus(messages.error, 'error'));
      };
      document.addEventListener(StandardEvents.cartLinesUpdate, onCartChange);
      document.addEventListener(StandardEvents.cartDiscountUpdate, onCartChange);
    });
    notice = sessionStorage.getItem('gs-reward-notice') || '';
    refreshCart(true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
